import {
  OPEN_APPROVAL_MODAL,
  OPEN_PROCESS_MODAL,
  OPEN_INFO_MODAL,
  OPEN_REFERENCE_MODAL,
  OPEN_CONTRIBUTOR_MODAL,
  OPEN_COMMENT_MODAL,
  CLOSE_APPROVAL_MODAL,
  CLOSE_PROCESS_MODAL,
  CLOSE_INFO_MODAL,
  CLOSE_REFERENCE_MODAL,
  CLOSE_CONTRIBUTOR_MODAL,
  CLOSE_COMMENT_MODAL
} from "./types";

export const openProcessModal = () => dispatch => {
  dispatch({ type: OPEN_PROCESS_MODAL });
};

export const closeProcessModal = () => dispatch => {
  dispatch({ type: CLOSE_PROCESS_MODAL });
};

export const openApprovalModal = () => dispatch => {
  dispatch({ type: OPEN_APPROVAL_MODAL });
};

export const closeApprovalModal = () => dispatch => {
  dispatch({ type: CLOSE_APPROVAL_MODAL });
};

export const openInfoModal = () => dispatch => {
  dispatch({ type: OPEN_INFO_MODAL });
};

export const closeInfoModal = () => dispatch => {
  dispatch({ type: CLOSE_INFO_MODAL });
};

export const openContributorModal = () => dispatch => {
  dispatch({ type: OPEN_CONTRIBUTOR_MODAL });
};

export const closeContributorModal = () => dispatch => {
  dispatch({ type: CLOSE_CONTRIBUTOR_MODAL });
};

export const openReferenceModal = () => dispatch => {
  dispatch({ type: OPEN_REFERENCE_MODAL });
};

export const closeReferenceModal = () => dispatch => {
  dispatch({ type: CLOSE_REFERENCE_MODAL });
};

export const openCommentModal = () => dispatch => {
  dispatch({ type: OPEN_COMMENT_MODAL });
};

export const closeCommentModal = () => dispatch => {
  dispatch({ type: CLOSE_COMMENT_MODAL });
};
